import { render } from "./HelpDeleteBom.vue?vue&type=template&id=48a171f8"
import script from "./HelpDeleteBom.vue?vue&type=script&lang=js"
export * from "./HelpDeleteBom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__